import React from 'react';
import { AirtableDataConsumer, AirtableContextData } from '../core/AirtableDataProvider';
import { Link } from 'gatsby';

interface Props { }

export default class CallToAction extends React.Component<Props> {

  render()
  {
    return (
      <AirtableDataConsumer>
        { data => data && this._render(data) }
      </AirtableDataConsumer>
    );
  }

  _render(data: AirtableContextData)
  {
    const cta = data.pageParameters.getSingleOrNull('CallToAction');

    if (cta === null) {
      return null;
    }

    const caption = cta.Value || 'contact us now';
    const message = cta.Content;

    return (
      <div className="flex justify-center white theme--secondary-background-color">
        <div className="flex-auto wfull flex-l flex-row items-center ttu pv5 ph4">
          <div className="flex-auto f3 b">
            { message }
          </div>
          <Link to="/contact#form" className="link dim bg-white gray b pa3 br1 db mt4 mt0-l mw5-ns">
            { caption }
          </Link>
        </div>
      </div>
    );

  }

}